import {Fragment} from "preact";
import s from "./bullet.module.css";
import {useAppContext} from "../../../../../contexts";

const Bullet = (props) => {
    // Destructured props
    const {
        currentStep,
        stepsAmount,
        step = 0
    } = props;

    // Accessibility feature data
    const {highContrast} = useAppContext();

    // Checks whether the current bullet is active or not
    const isActive = currentStep === step;

    // The active bullet content
    const activeContent = (
        <p className={`overflow-hidden ${s.activeLabel} ${!isActive ? s.disabledLabel : ""}`}>
            {step}
            <span className={"font-normal"}>
                &nbsp;de&nbsp;
            </span>
            {stepsAmount}
        </p>
    )

    return (
        <Fragment>
            <div className={
                `${s.bullet} ${
                    isActive ? (
                        highContrast ? s.dmActiveBullet : s.activeBullet
                    ) : currentStep < step ? (
                        highContrast ? s.dmNextBullet : s.nextBullet
                    ) : s.disabledBullet
                }`
            }>
                {activeContent}
            </div>
        </Fragment>
    )
}

export default Bullet;
